import { Typography, Grid, Box } from "@mui/material"
import { detailsValue, labelText, labelTitle, subPanelHeader } from "../../../../../assets/styles/appStyles"
import { gridContainer, infoGridItem } from "../../../Styles/CustodianAddressDetailsStyles"
import { EntityMetric } from "../../../../../Models/custodian/entity-custodian-details-viewmodel";
import { emptyValue } from "../../../../../settings/appConfig";

const OtherInfoDetails = ({
    otherInfo,
}: {
    otherInfo?: EntityMetric | null;
}) => {
    return (
        <>
            <Typography sx={subPanelHeader}>Others</Typography>
            <Grid rowSpacing={3} container sx={gridContainer} spacing={2}>
                <Grid container item rowSpacing={3}>
                    <Grid item xs={6} sx={infoGridItem}>
                        <Typography sx={labelTitle}>Last Record Retrieved Date</Typography>
                        <Box sx={detailsValue}>
                            {otherInfo?.lastRecordRetrievedDate ? otherInfo?.lastRecordRetrievedDate.toLocaleString().split('T')[0] : emptyValue}
                        </Box>
                    </Grid>
                    <Grid item xs={6} sx={infoGridItem}>
                        <Typography sx={labelTitle}>Average Processing Time</Typography>
                        <Box>
                            <Typography sx={labelText}>{otherInfo?.averageProcessingTime ? otherInfo?.averageProcessingTime :  emptyValue}</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default OtherInfoDetails